// extracted by mini-css-extract-plugin
export default {"image":"Excel_image__KzTA0"};